import { faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { faBlenderPhone, faEnvelope, faGlobe, faMap, faMobileAlt, faPhone } from '@fortawesome/free-solid-svg-icons'
import React from 'react'
import { Link } from 'react-router-dom'
import {FooterContainer} from '../../styles/Header'
import logo from "../../mainlogo.png";
import logo2 from "../../daha-iyiye.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
export default function Footer() {
  return (
    <FooterContainer>
      <div className="copyright">
        <div className='logos' > 
          <img src={logo} alt="logo" />
        </div>
        <div className="main">
          {/* <div onClick={() => window.open("tel:+902126566006")}>
            <FontAwesomeIcon icon={faPhone} /> +90 212 656 60 06
          </div>
          <div onClick={() => window.open("tel:+905496566006")}>
            <FontAwesomeIcon icon={faMobileAlt} /> +90 549 656 60 06
          </div> */}
          <div onClick={() => window.open("mailto:info@conteyner.com")}>
            <FontAwesomeIcon icon={faEnvelope} /> info@conteyner.com
          </div>
        </div>
        <div
          onClick={() =>
            window.open(
              "https://www.google.com/maps/place/conteyner+Spor/@41.0075099,28.9634691,17z/data=!3m1!4b1!4m6!3m5!1s0x14cab0915de3ee5f:0x86f59b0a78cd1259!8m2!3d41.00751!4d28.9683454!16s%2Fg%2F11c6cww8z4?entry=ttu"
            )
          }
          style={{
            marginTop: 10,
            marginBottom: 10,
            fontSize: 15,
            cursor: "pointer",
          }}
        >
          {/* Göztepe mah. 2374. sokak <br /> No : 1{" "}
          <strong>Bağcılar/İstanbul</strong> */}
        </div>
        <div> Tüm hakları sakldırı &copy; 2023</div>
        <div><img src="https://dehasoft.com.tr/dehasoftblack.png"  className='dehasoft-img'  onClick={() => window.open("https://dehasoft.com.tr/", "_blank")} /></div>
      </div>
    </FooterContainer>
  );
}
